import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Row, Col} from 'antd'
import { FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import _ from 'lodash'


@Form.create()

class documentTemplates extends Component {
  state = {
    allNotifications:[],
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    typeArr:['Board', 'University']
  }


  handleSubmit = e => {
    const { form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
        if(!err) {
            let values = _.clone(valData);
            let x = await Request.uploadSampleDocuments(values)
            if (!x.error) {
              notification.success({
                  message: x.message
              })
              window.location.reload();
          } else {
              notification.error({
                  message: 'Error Saving',
                  description: x.message
              })
          }
        }
    })
  }

  async componentDidMount() {
    let response = await Request.getAllPayrollDocuments();
    this.props.form.setFieldsValue(response.data)
  }


  render() {
    const {
      form: {getFieldDecorator}
    } = this.props

      const inputTypes = {
        fields: [
            {
                title:'Experience Letter Sample',
                key:'experienceLetter',
                type:'file'
            },
            {
                title:'Employee Agreement Sample',
                key:'employeeAgreement',
                type:'file'
            },
            {
                title:'Letter of Intent Sample',
                key:'letterOfIntent',
                type:'file'
            },
            {
              title:'Performance Appraisal Letter',
              key:'performanceAppraisalLetter',
              type:'file'
            },
            {
              title:'Annual Appraisal Letter',
              key:'annualAppraisalLetter',
              type:'file'
            },
            {
              title:'Appointment Letter',
              key:'appointmentLetter',
              type:'file'
            },
            {
              title:'Salary Slip',
              key:'salarySlip',
              type:'file'
            },
            {
              title:'Policies',
              key:'policies',
              type:'file'
            }
        ]
      };
    return (
      <PageHeaderWrapper title={` Document Templates :`}>
        <Card bordered={true}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col>
                        <GetAllFormFields
                            inputSchema={inputTypes}
                            apiurl={LAPI_URL}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
            </Form>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default documentTemplates
